module.exports = __webpack_public_path__ + "10f553013a39a23752c306ac3742cb8b.png";